import React from 'react';
import PropTypes from 'prop-types';
import { CustomerContext } from "./CustomerContext.js";
export const CustomerProvider = _ref => {
  let {
    children
  } = _ref;
  const isServer = !(typeof window !== 'undefined' && window.document && window.document.createElement);
  const persistedCustomerInformationContext = {
    membershipInformation: null,
    THDCustomer: null,
    isExchangeCustomer: false,
    exchangeCustomerCookies: null,
    isStorefrontCustomer: false
  };

  /**
   * On page load, we attempt to get the values from local storage first and set context.
   *
   * If we have them, we can pass them down to the consumer (the useMembershipInformation hook).
   *
   * If we don't have them, we'll pass down the default null values and let the consumer...
   *
   * TODO: have consuming child update membershipInformation when call to Loyalty is made^
   */
  if (!isServer) {
    var _window$THDCustomer, _window$THDCustomer$d, _window$THDCustomer2, _window$THDCustomer3, _window$THDCustomer3$, _window$THDCustomer4, _window$THDCustomer4$, _window$THDCustomer5, _window$THDCustomer5$;
    persistedCustomerInformationContext.membershipInformation = (_window$THDCustomer = window.THDCustomer) === null || _window$THDCustomer === void 0 ? void 0 : (_window$THDCustomer$d = _window$THDCustomer.default) === null || _window$THDCustomer$d === void 0 ? void 0 : _window$THDCustomer$d.membershipInformation;
    persistedCustomerInformationContext.THDCustomer = (_window$THDCustomer2 = window.THDCustomer) === null || _window$THDCustomer2 === void 0 ? void 0 : _window$THDCustomer2.default;
    persistedCustomerInformationContext.isExchangeCustomer = (_window$THDCustomer3 = window.THDCustomer) === null || _window$THDCustomer3 === void 0 ? void 0 : (_window$THDCustomer3$ = _window$THDCustomer3.default) === null || _window$THDCustomer3$ === void 0 ? void 0 : _window$THDCustomer3$.isExchangeCustomer;
    persistedCustomerInformationContext.exchangeCustomerCookies = (_window$THDCustomer4 = window.THDCustomer) === null || _window$THDCustomer4 === void 0 ? void 0 : (_window$THDCustomer4$ = _window$THDCustomer4.default) === null || _window$THDCustomer4$ === void 0 ? void 0 : _window$THDCustomer4$.exchangeCustomerCookies;
    persistedCustomerInformationContext.isStorefrontCustomer = (_window$THDCustomer5 = window.THDCustomer) === null || _window$THDCustomer5 === void 0 ? void 0 : (_window$THDCustomer5$ = _window$THDCustomer5.default) === null || _window$THDCustomer5$ === void 0 ? void 0 : _window$THDCustomer5$.isStorefrontCustomer;
  }
  return /*#__PURE__*/React.createElement(CustomerContext.Provider, {
    value: persistedCustomerInformationContext
  }, children);
};
CustomerProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
CustomerProvider.defaultProps = {
  children: null
};
//# sourceMappingURL=CustomerProvider.js.map